




















import {Component, Vue} from 'vue-property-decorator'
import firebase from 'firebase/app'
import 'firebase/firestore'


@Component
export default class SettingUser extends Vue {
  private alert = {
    show: false,
    type: 'success',
    message: '登録完了',
  }
  private confirmDialog = false

  private showAlert(success: boolean, message: string) {
    if (success) {
      this.alert.type = 'success'
    } else {
      this.alert.type = 'error'
    }
    this.alert.message = message
    this.alert.show = true
  }

  private async removeUser() {
    try {
      const user = firebase.auth().currentUser!
      await user.delete()
      location.reload()
    } catch (e) {
      this.confirmDialog = false
      this.showAlert(false, '再度ログインし直してから実行してください')
    }
  }
}
